import { IconTooltip } from 'utils/components/IconTooltip';
import React from 'react';
import FillNode from './FillNode';
import { OrderSide } from 'communication/types/order/OrderSide';
import FillSize from './FillSize';
import './OrderFillsHelp.scss';
import { Icon } from '@instinet-analytics/semantic-ui-components';

interface OrderFillsHelpProps {
    side?: OrderSide;
}
export default function OrderFillsHelp({ side }: OrderFillsHelpProps) {
    return (
        <IconTooltip>
            <div>
                This chart visualizes your order information in real time,
                placed on top of the symbol&apos;s intraday price and volume
                chart.
            </div>
            <div>
                <h1>Fills</h1>
            </div>
            <div className="order-fills-help-text-with-diagram">
                <FillNode side={side} />
                <div>
                    Indicates the instances that a single or a group of fills
                    occurred. These are grouped by time bins which can be
                    changed in the chart&apos;s configuration{' '}
                    <Icon name="cog" />.
                </div>
            </div>
            <div>
                <h1>Fill Size</h1>
            </div>
            <div className="order-fills-help-text-with-diagram">
                <FillSize side={side} />
                <div>
                    The size of the bars corresponds to the size of the fills:
                    the larger the bar, the more shares executed
                </div>
            </div>
        </IconTooltip>
    );
}
